import React from 'react';
import PropTypes from 'prop-types';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import classNames from 'classnames';

const Table = (props) => {
    const Header = props.headerComponent || TableHeader;
    const Body = props.bodyComponent || TableBody;

    return (
        <table className={classNames('ui-table ui-table_sortable', props.cssClass)}>
            <Header
                columns={props.columns}
                rows={props.rows}
                selectedRows={props.selectedRows}
                onSort={props.onSort}
                sortOrder={props.sortOrder}
                {...props.headerProps}
            >
                {props.header}
            </Header>
            <Body
                columns={props.columns}
                selectedRows={props.selectedRows}
                errorMessage={props.children}
                colSpanGetter={props.colSpanGetter}
                {...props.bodyProps}
            >
                {props.rows}
            </Body>
        </table>
    );
};

Table.propTypes = {
    cssClass: PropTypes.string,
    headerComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
    headerProps: PropTypes.object,
    bodyComponent: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.func,
    ]),
    bodyProps: PropTypes.object,
    header: PropTypes.array,
    columns: PropTypes.array,
    sortOrder: PropTypes.number,
    rows: PropTypes.array,
    selectedRows: PropTypes.array,
    onSort: PropTypes.func,
    children: PropTypes.string,
    colSpanGetter: PropTypes.func
};

Table.defaultProps = {
    cssClass: 'ui-table_type1',
    children: 'No data'
};

export default Table;



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/components/Table.js